import { moderation } from './misc'

export default {
  title: 'Rules',

  titles: {
    actions: 'Actions',
    conditions: 'Conditions'
  },

  labels: {
    title: 'Rule title',
    type: 'Type',
    text: 'Text',
    sender: 'Sender',
    routingRule: 'Rule',
    condition: 'Condition',
    providerGroup: 'Providers group',
    percentage: 'Percentage',
    search: 'Search',
    textToCheck: 'Text to check',
    phone: 'Phone to check',
    keywords: 'Keywords lists',
    contactList: 'Contact list',
    messagePattern: 'Moderation patterns',
    fallbacks: 'Fallbacks',
    buttons: 'Buttons',
    urlShortenerPresetId: 'Preset',
    mccmnc: 'MCC MNC',
    recipient: 'Recipient',
    yulore: 'Yulore',

    group: {
      pattern: 'Pattern for search group'
    },

    add: {
      condition: 'Add condition'
    },

    ...moderation
  },

  tags: {
    text: 'Text',
    sender: 'Sender',
    recipient: 'Recipient',
    code: 'Operator code',
    group: 'Operator group',
    mcc: 'MCC',
    mnc: 'MNC',
    mccmnc: 'MCC MNC',
    contactList: 'Contact list',
    messagePattern: 'Moderation patterns',
    type: 'Type',
    moderation: 'Moderation',
    keywords: 'Keywords',
    fallbacks: 'Fallbacks',
    buttons: 'Buttons',
    urlShortenerPresetId: 'Short links preset',
    yulore: 'Yulore'
  },

  hints: {
    noRule: 'Condition not selected yet. Click on this line to select.',
    phone: 'Enter a phone number in this field to check whether it exists in selected contact lists.',
    yulore: 'You can enter any integer values.<br>Type a number and press Enter or blur the field to add it.<br>If the number is already in the list, it will be removed.'
  },

  buttons: {
    add: {
      rule: 'Add rule',
      group: 'Add group',
      condition: 'Add condition'
    },
    remove: {
      rule: 'Remove rule',
      group: 'Remove group'
    }
  }
}
